import {
  useRemoteStorage,
  WHATS_NEW_INCLUDE_COMPETITORS,
  WHATS_NEW_PERIOD,
  WHATS_NEW_SELECTED_WATCHLISTS,
} from '@terminal/hooks/use-remote-storage';

import { DEFAULT_WHATS_NEW_PERIOD } from '../types';

export const useWhatsNewSettings = () => {
  const items = useRemoteStorage(state => state.items);
  return {
    selectedWatchlists: items?.[WHATS_NEW_SELECTED_WATCHLISTS],
    period: items?.[WHATS_NEW_PERIOD] ?? DEFAULT_WHATS_NEW_PERIOD,
    includeCompetitors: items?.[WHATS_NEW_INCLUDE_COMPETITORS],
  };
};
